import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
  name: "config",
  initialState: {
    config: {},
    baseConfig: {},
  },

  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    setBaseConfig: (state, action) => {
      state.baseConfig = action.payload;
    },
    setLoggedOutUser: (state) => {
      state.user = null;
    },
  },
});

export const setConfig = configSlice.actions.setConfig;
export const setBaseConfig = configSlice.actions.setBaseConfig;

export default configSlice.reducer;
